function checkFormTypePermission(currentUser, schemaId, operation) {
  if (
    currentUser &&
    currentUser.userGroup &&
    currentUser.userGroup.permission &&
    currentUser.userGroup.permission.formTypes &&
    currentUser.userGroup.permission.formTypes[schemaId] &&
    currentUser.userGroup.permission.formTypes[schemaId][operation]
  ) {
    return true;
  }
  return false;
}

export default checkFormTypePermission;
